import { HisInformationErrorResult } from "./HisInformationErrorResult";

export class HisInformationProcessResult {
  errorResults: HisInformationErrorResult[];
}
